import React from "react";

import { useLoadingProducts } from "./hooks/useLoadingProducts";
import { formatCurrency } from "./utils/formatCurrency";

export function Produtos() {
const { data, navigateViewProduct } = useLoadingProducts();


  return (
    <>
      <h1 className="azul-cabecalho">Produtos</h1>
      <p className="subheader-text mb-10">Produtos Jusfinder</p>
        <div className="row mb-10">
          <div className="col-xl-12">
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #eaeaea",
                borderRadius: "5px",
                padding: "20px"
              }}
            >
              <div className="row mb-5">
                <h3> Lista de produtos</h3>
                <table className="table table-bordered table-striped table-sm">
                  <thead className="light">
                    <tr>
                      <th>id</th>
                      <th>Nome</th>
                      <th>Descrição</th>
                      <th>Preço</th>
											<th>Preço universal</th>
                      <th>Identificação</th>
                      <th>Ações</th>
                    </tr>
                  </thead>                  
									<tbody>
                    {data &&
                      data.map(query => (
                        <tr key={query.id}>
                          <td>
                            {query.id}
                          </td>
                          <td>{query.name}</td>
                          <td>{query.description}</td>
                          <td>{formatCurrency(query.price)}</td>
													<td>{query.universalPrice}</td>
                          <td>{query.identification}</td>
                      
                          <td>
                            <button
                              type="button"
                              className="btn btn-icon btn-primary"
                              onClick={() => navigateViewProduct(query.id)}
                            >
                              <i className="flaticon-edit"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

    
    </>
  );
}
